import { cn } from '@/lib/utils'

export const AddButton = () => {
  return (
    <button
      type="submit"
      className={cn(
        'bg-[#18181b]',
        'text-[12px] font-medium leading-[20px] text-primary-foreground',
        'rounded-[6px]',
        'px-2 py-1'
      )}
    >
      Add
    </button>
  )
}
